import Vue from 'vue'

// Import component files
import FormatItem from './components/common/FormatItem.vue'
import BannerItem from './components/common/BannerItem.vue'
import PreviewSettings from './components/common/PreviewSettings.vue'
import InputSearch from './components/common/InputSearch.vue'
import InputField from './components/common/InputField.vue'
import MainNavigation from './components/common/MainNavigation.vue'
import MainFooter from './components/common/MainFooter.vue'
import CategoriesListing from './components/common/CategoriesListing.vue'
import FormatListing from './components/common/FormatListing.vue'

// Standalone components
Vue.component('format-item', FormatItem)
Vue.component('banner-item', BannerItem)
Vue.component('preview-settings', PreviewSettings)
Vue.component('input-field', InputField)
Vue.component('input-search', InputSearch)

// Grouped components
Vue.component('main-navigation', MainNavigation)
Vue.component('main-footer', MainFooter)
Vue.component('categories-listing', CategoriesListing)
Vue.component('format-listing', FormatListing)



// WEBPACK FOOTER //
// ./src/components.js